import { APP_INITIALIZER, Provider } from '@angular/core';
import { EnvironmentService } from '../services/environment.service';

export const EnvironmentProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: (environmentService: EnvironmentService) => () => {
    return environmentService.load();
  },
  deps: [EnvironmentService],
  multi: true,
};
